import { useContextEnsuringProvider } from '@iheartjane/utils';
import type { PropsWithChildren } from 'react';
import { createContext } from 'react';

interface JaneModeContext {
  isJaneMode: boolean;
}

/**
 * "Jane Mode" refers to applying the default theme, when a store does not have a custom theme color.
 * Jane Mode is currently designed to include:
 *   1. White landing page with black buttons
 *   2. Ultralight header
 *   3. Brand Purple primary buttons (Add to bag, Search, etc.)
 */
const JaneModeContext = createContext<boolean | null>(null);
JaneModeContext.displayName = 'JaneMode';

export const JaneModeProvider = ({
  children,
  isJaneMode,
}: PropsWithChildren<JaneModeContext>) => {
  return (
    <JaneModeContext.Provider value={isJaneMode}>
      {children}
    </JaneModeContext.Provider>
  );
};

export const useKioskJaneModeContext = () =>
  useContextEnsuringProvider(JaneModeContext);
